import React from 'react';
import {useState,useEffect,Component} from 'react';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';





/* Import home from File */





import Home from './home.js';

//NEW MIS
import SP_admins from './SuperAdmin/admins.js';
import SP_create_admin from './SuperAdmin/create_admin.js';
import SP_edit_admin from './SuperAdmin/edit_admin.js';
import SP_admin_login from './Admin/login.js';
import SP_superadmin_login from './SuperAdmin/login.js';
import SP_teams from './SuperAdmin/teams.js';
import SP_create_team from './SuperAdmin/create_team.js';
import SP_edit_team from './SuperAdmin/edit_team.js';
import SP_brokers from './SuperAdmin/brokers.js';
import SP_create_broker from './SuperAdmin/create_broker.js';
import SP_edit_broker from './SuperAdmin/edit_broker.js';
import SP_cash from './SuperAdmin/bpm.js';
import SP_bank from './SuperAdmin/banks.js';
import SP_sales from './SuperAdmin/sales.js';
import SP_stock from './SuperAdmin/stocks.js';
import Admin_login from './Admin/login.js';
import Admin_teams from './Admin/teams.js';
import Admin_create_team from './Admin/create_team.js';
import Admin_edit_team from './Admin/edit_team.js';
import Admin_brokers from './Admin/brokers.js';
import Admin_create_broker from './Admin/create_broker.js';
import Admin_edit_broker from './Admin/edit_broker.js';
import Admin_cash from './Admin/bpm.js';
import Admin_bank from './Admin/banks.js';
import Admin_sales from './Admin/sales.js';
import Admin_stock from './Admin/stocks.js';
import Team_login from './Team/login.js';
import Team_brokers from './Team/brokers.js';
import Team_create_broker from './Team/create_broker.js';
import Team_cash from './Team/bpm.js';
import Team_bank from './Team/banks.js';
import Team_sales from './Team/sales.js';
import Team_stock from './Team/stocks.js';
import Team_transactions from './Team/transactions.js';
import Admin_transactions from './Admin/transactions.js';
import SP_transactions from './SuperAdmin/transactions.js';
import Admin_dispatch_list from './Admin/dispatch_list.js';
import Team_dispatch_list from './Team/dispatch_list.js';
import SP_dispatch_list from './SuperAdmin/dispatch_list.js';
import SP_login_history from './SuperAdmin/login_history.js';
import Admin_login_history from './Admin/login_history.js';
import SP_daysummary from './SuperAdmin/daysummary.js';
import Admin_daysummary from './Admin/daysummary.js';
import Team_vendorsummary from './Team/vendorsummary.js';
import Admin_vendorsummary from './Admin/vendorsummary.js';
import SP_vendorsummary from './SuperAdmin/vendorsummary.js';
import SP_vendors from './SuperAdmin/vendors.js';
import Team_production from './Team/production.js';
import Team_vendors from './Team/vendors.js';
import Admin_vendors from './Admin/vendors.js';
import Admin_production from './Admin/production.js';
import Sp_production from './SuperAdmin/production.js';
import Team_debtors from './Team/debtors.js';
import Team_debtorpayment from './Team/debtor_payment.js';
import Admin_debtors from './Admin/admin_debtors.js';
import Admin_debtorpayment from './Admin/debtor_payment.js';
import SP_debtors from './SuperAdmin/debtors.js';
import SP_debtorpayment from './SuperAdmin/debtor_payment.js';
import SP_edit_debtorpayment from './SuperAdmin/edit_debtor_payment.js';
import Admin_brokersummary from './Admin/brokersummary.js';
import SP_brokersummary from './SuperAdmin/brokersummary.js';
import Team_brokersummary from './Team/brokersummary.js';
import Team_broker_debtors from './Team/broker_debtors.js';
import Admin_broker_debtors from './Admin/broker_debtors.js';
import SP_broker_debtors from './SuperAdmin/broker_debtors.js';
import SP_edit_production from './SuperAdmin/edit_production.js';
import SP_edit_sales from './SuperAdmin/edit_sales.js';
import SP_daysummary1 from './SuperAdmin/daysummary1.js';
import Admin_daysummary1 from './Admin/daysummary1.js';


function Routestosite(){

    return(
<>
<Router>
   <Routes>

   <Route exact path='/home' element={<Home />} />
   <Route exact path='/' element={<Home />} />

   <Route exact path='/home1' element={<Home />} />


    //NEW SUGAR MILL MIS

    //SUPER ADMIN PANEL
   <Route exact path='/spadminpanel-dashboard-spadmin-login' element={<SP_superadmin_login />} />
   <Route exact path='/spadminpanel-dashboard-admins' element={<SP_admins />} />
   <Route exact path='/spadminpanel-dashboard-create-admin' element={<SP_create_admin />} />
   <Route exact path='/spadminpanel-dashboard-edit-admin' element={<SP_edit_admin />} />
   <Route exact path='/spadminpanel-dashboard-teams' element={<SP_teams />} />
   <Route exact path='/spadminpanel-dashboard-create-team' element={<SP_create_team />} />
   <Route exact path='/spadminpanel-dashboard-edit-team' element={<SP_edit_team />} />
   <Route exact path='/spadminpanel-dashboard-brokers' element={<SP_brokers />} />
   <Route exact path='/spadminpanel-dashboard-create-broker' element={<SP_create_broker />} />
   <Route exact path='/spadminpanel-dashboard-edit-broker' element={<SP_edit_broker />} />
   <Route exact path='/spadminpanel-dashboard-bpm' element={<SP_cash />} />
   <Route exact path='/spadminpanel-dashboard-bank' element={<SP_bank />} />
   <Route exact path='/spadminpanel-dashboard-sales' element={<SP_sales />} />
   <Route exact path='/spadminpanel-dashboard-stock' element={<SP_stock />} />
   <Route exact path='/spadminpanel-dashboard-transactions' element={<SP_transactions />} />
   <Route exact path='/spadminpanel-dashboard-dispatchhistory' element={<SP_dispatch_list />} />
   <Route exact path='/spadminpanel-dashboard-loginhistory' element={<SP_login_history />} />
   <Route exact path='/spadminpanel-dashboard-daysummary' element={<SP_daysummary />} />
   <Route exact path='/spadminpanel-dashboard-daysummary-today' element={<SP_daysummary1 />} />
   <Route exact path='/spadminpanel-dashboard-vendorsummary' element={<SP_vendorsummary />} />
   <Route exact path='/spadminpanel-dashboard-vendors' element={<SP_vendors />} />
   <Route exact path='/spadminpanel-dashboard-production' element={<Sp_production />} />
   <Route exact path='/spadminpanel-dashboard-vendorpayments' element={<SP_debtors />} />
   <Route exact path='/spadminpanel-dashboard-debtorpayment' element={<SP_debtorpayment />} />
   <Route exact path='/spadminpanel-dashboard-edit-debtorpayment' element={<SP_edit_debtorpayment />} />
   <Route exact path='/spadminpanel-dashboard-brokersummary' element={<SP_brokersummary />} />
   <Route exact path='/spadminpanel-dashboard-broker-vendorsummary' element={<SP_broker_debtors />} />
   <Route exact path='/spadminpanel-dashboard-edit-production' element={<SP_edit_production />} />
   <Route exact path='/spadminpanel-dashboard-edit-sales' element={<SP_edit_sales />} />

   //ADMIN PANEL
   <Route exact path='/adminpanel-dashboard-admin-login' element={<Admin_login />} />
   <Route exact path='/adminpanel-dashboard-teams' element={<Admin_teams />} />
   <Route exact path='/adminpanel-dashboard-create-team' element={<Admin_create_team />} />
   <Route exact path='/adminpanel-dashboard-edit-team' element={<Admin_edit_team />} />
   <Route exact path='/adminpanel-dashboard-brokers' element={<Admin_brokers />} />
   <Route exact path='/adminpanel-dashboard-create-broker' element={<Admin_create_broker />} />
   <Route exact path='/adminpanel-dashboard-edit-broker' element={<Admin_edit_broker />} />
   <Route exact path='/adminpanel-dashboard-bpm' element={<Admin_cash />} />
   <Route exact path='/adminpanel-dashboard-bank' element={<Admin_bank />} />
   <Route exact path='/adminpanel-dashboard-sales' element={<Admin_sales />} />
   <Route exact path='/adminpanel-dashboard-stock' element={<Admin_stock />} />
   <Route exact path='/adminpanel-dashboard-transactions' element={<Admin_transactions />} />
   <Route exact path='/adminpanel-dashboard-dispatchhistory' element={<Admin_dispatch_list />} />
   <Route exact path='/adminpanel-dashboard-loginhistory' element={<Admin_login_history />} />
   <Route exact path='/adminpanel-dashboard-daysummary' element={<Admin_daysummary />} />
   <Route exact path='/adminpanel-dashboard-daysummary-today' element={<Admin_daysummary1 />} />
   <Route exact path='/adminpanel-dashboard-vendorsummary' element={<Admin_vendorsummary />} />
   <Route exact path='/adminpanel-dashboard-vendors' element={<Admin_vendors />} />
   <Route exact path='/adminpanel-dashboard-production' element={<Admin_production />} />
   <Route exact path='/adminpanel-dashboard-vendorpayments' element={<Admin_debtors />} />
   <Route exact path='/adminpanel-dashboard-debtorpayment' element={<Admin_debtorpayment />} />
   <Route exact path='/adminpanel-dashboard-brokersummary' element={<Admin_brokersummary />} />
   <Route exact path='/adminpanel-dashboard-broker-vendorsummary' element={<Admin_broker_debtors />} />

   //TEAM PANEL
   <Route exact path='/teampane--dashboard-team-login' element={<Team_login />} />
   <Route exact path='/teampane--dashboard-brokers' element={<Team_brokers />} />
   <Route exact path='/teampane--dashboard-create-broker' element={<Team_create_broker />} />
   <Route exact path='/teampane--dashboard-bpm' element={<Team_cash />} />
   <Route exact path='/teampane--dashboard-bank' element={<Team_bank />} />
   <Route exact path='/teampane--dashboard-sales' element={<Team_sales />} />
   <Route exact path='/teampane--dashboard-stock' element={<Team_stock />} />
   <Route exact path='/teampane--dashboard-transactions' element={<Team_transactions />} />
   <Route exact path='/teampane--dashboard-dispatchhistory' element={<Team_dispatch_list />} />
   <Route exact path='/teampane--dashboard-vendorsummary' element={<Team_vendorsummary />} />
   <Route exact path='/teampane--dashboard-vendors' element={<Team_vendors />} />
   <Route exact path='/teampane--dashboard-production' element={<Team_production />} />
   <Route exact path='/teampane--dashboard-vendorpayments' element={<Team_debtors />} />
   <Route exact path='/teampane--dashboard-debtorpayment' element={<Team_debtorpayment />} />
   <Route exact path='/teampane--dashboard-brokersummary' element={<Team_brokersummary />} />
   <Route exact path='/teampane--dashboard-broker-vendorsummary' element={<Team_broker_debtors />} />

   </Routes>
   </Router>
</>
    );


}

export default Routestosite;